<template>
  <div class="v3-style-bottom" :class="{ mobile: isMobile ? true : false }" @click="handleClick">
    <img class="bottom-bg" src="/img/styles/bottomIcon/V3Bk.png" v-if="!isMobile" />
    <div
      class="menu-box"
      v-if="!isMobile"
      :style="{
        height: $h_Ratio(menuStyle.height, $store) + 'px',
        minWidth: $w_Ratio(menuStyle.width, $store) + 'px',
      }"
      :class="{ 'menu-down': !isOpenBottomMenu }"
    >
      <!-- <img class="bottom-bg" src="@/assets/img/style1/bottom_menu_bg.png" /> -->

      <div
        class="menu-list"
        :style="{
          top: $h_Ratio(-24, $store) + '%',
        }"
      >
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
          :id="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <!-- 背景 -->
            <!-- <div class="bk">
               <img src="/img/styles/menusIcons/bottomIcon/V3bottom.png"
                   alt="" />
            </div> -->
            <img :src="item.IconPath" alt="" class="img" />
          </div>
          <!-- :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }" -->
          <div
            class="menu-item-icon-name"
            :class="{ activeName: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
    <div class="toggle-open-btn" v-if="!isMobile" :style="getToggleOpenBtn()" @click="toggleOpen">
      <i :class="isOpenBottomMenu ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>

    <!-- 手机端 -->
    <div class="mobile-menu" v-if="isMobile">
      <div class="icon" @click="isShow = !isShow">
        <img src="@/assets/img/mobile/menu.png" alt="" />
      </div>
      <div
        class="scene"
        :style="{
          left: isShow ? '0%' : '150px',
          height: `${$w_Ratio(1000, $store)}px`,
        }"
      >
        <div
          class="menu-item"
          :style="getMenuMobileItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <!-- <img
              :src="item.IconActivePath"
              v-if="item.id === $store.state.ProjectInfo.CurrentScene.id"
              alt=""
            /> -->
            <!-- <img src="/img/styles/menusIcons/bottomIcon/V3bottom.png"
                 alt=""
                 class="bk" /> -->

            <img :src="item.IconPath" alt="" class="pic" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'V3StyleBottom',
  components: {},
  props: {
    Configuration: Object,
    SceneryList: Array,
  },
  data() {
    return {
      isShow: false,
      isOpenBottomMenu: true,
      stylelabel: {
        // height: 100,
      },
      menuStyle: {
        height: 85,
        width: 700,
      },
      menuItemStyle: {},
      backgroundDefault: null, // 临时存储原来背景
    };
  },
  watch: {
    SceneryList: {
      deep: true,
      handler: function (newVal) {
        this.setMenuShowLength(newVal);
      },
    },
  },
  // created() {
  //   this.setMenuShowLength(this.SceneryList);
  //   if (this.Configuration.propertyData.menuStyle) {
  //     this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
  //   }
  // },
  mounted() {
    this.setMenuShowLength(this.SceneryList);
    if (this.Configuration.propertyData.menuStyle) {
      this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    }
    this.SceneryList.sort((a, b) => {
      return a.sceneSortIndex - b.sceneSortIndex;
    });
    this.backgroundDefault = this.$store.state.ProjectInfo.Background;
  },
  methods: {
    ...mapMutations(['set_CurrentScene', 'set_ProjectBackground', 'set_CurrentConfigration']),
    setMenuShowLength(SceneryList) {
      if (SceneryList.length > 4) {
        this.menuStyle.width = 700 + (SceneryList.length - 4) * 95;
      }
      if (this.Configuration.propertyData.menuStyle) {
        this.$store.commit('set_ProjectStylePropertyData', {
          key: 'menuStyle',
          value: this.$_.cloneDeep(this.menuStyle),
        });
      }
    },
    toggleOpen() {
      this.isOpenBottomMenu = !this.isOpenBottomMenu;
    },
    handleSwitchScene(item) {
      this.set_CurrentScene(item.id);
      this.isShow = false;
      if (item.isChangeBk === true) {
        if (item.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          if (
            backgroundDefault == null ||
            backgroundDefault == 'null' ||
            backgroundDefault == undefined ||
            backgroundDefault == 'undefined'
          ) {
            this.set_ProjectBackground(this.backgroundDefault);
            this.set_CurrentConfigration(this.backgroundDefault);
          } else {
            this.set_ProjectBackground(backgroundDefault);
            this.set_CurrentConfigration(backgroundDefault);
          }
        } else {
          this.set_ProjectBackground(item.Background);
          this.set_CurrentConfigration(item.Background);
        }
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        if (
          backgroundDefault == null ||
          backgroundDefault == 'null' ||
          backgroundDefault == undefined ||
          backgroundDefault == 'undefined'
        ) {
          this.set_ProjectBackground(this.backgroundDefault);
          this.set_CurrentConfigration(this.backgroundDefault);
        } else {
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        }
      }
    },
    getMenuStyle() {
      return {
        height: this.$h_Ratio(this.menuStyle.height, this.$store) + 'px',
        minWidth: this.$w_Ratio(this.menuStyle.width, this.$store) + 'px',
      };
    },
    getMenuItemStyle() {
      return {
        height: this.$w_Ratio(90, this.$store) + 'px',
        width: this.$w_Ratio(80, this.$store) + 'px',
        fontSize: '12px',
        margin: `0 ${this.$w_Ratio(12, this.$store)}px`,
      };
    },
    // 移动端按钮样式
    getMenuMobileItemStyle() {
      return {
        height: this.$w_Ratio(110, this.$store) + 'px',
        width: this.$w_Ratio(90, this.$store) + 'px',
        fontSize: this.$w_Ratio(36, this.$store) + 'px',
        margin: `${this.$w_Ratio(7, this.$store)}px 
               ${this.$w_Ratio(10, this.$store)}px`,
      };
    },

    getToggleOpenBtn() {
      return {
        height: this.$h_Ratio(13, this.$store) + 'px',
        width: this.$w_Ratio(150, this.$store) + 'px',
        fontSize: this.$w_Ratio(14, this.$store) + 'px',
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      SceneryList: state => state.ProjectInfo.SceneryList,
    }),
    newSceneryList() {
      return this.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mobile {
  top: 20px;
  right: 0 !important;
  width: 40px !important;
  left: unset !important;
  transform: none !important;
  height: 40px;
}

.v3-style-bottom {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  transition: all 0.3s linear;
  color: white;
  z-index: 99;
  height: 10%;

  .menu-box {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    transition: transform 0.3s linear;

    .bottom-bg {
      width: 100%;
      height: 90%;
      position: absolute;
      bottom: 0;
    }

    .menu-list {
      position: absolute;
      display: flex;
      top: -40%;
      left: 50%;
      transform: translateX(-50%);
      align-items: flex-end;
      justify-content: space-around;
      height: 100%;

      .menu-item {
        cursor: pointer;
        flex-shrink: 0;
        transition: all 0.3s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        .menu-item-icon-name {
          text-align: center;
          white-space: nowrap;
          font-size: 12px;
        }

        .menu-item-icon-ct {
          width: 100%;
          height: 100%;
          transition: all 0.3s ease-out;
          position: relative;
          top: 6px;
          z-index: 999999 !important;
          .bk {
            position: absolute;
            z-index: 1;
            bottom: 0;
            transition: all 0.3s ease-out;
          }

          img.img {
            position: relative;
            z-index: 2;
            width: 62%;
            // height: 70%;
            transition: all 0.3s ease-out;
            margin: 0 auto;
          }

          opacity: 0.8;
        }
        .active {
          opacity: 2 !important;
          top: -6px !important;
          width: 100% !important;
          height: 100% !important;
          img.img {
            width: 80%;
            height: 92%;
          }
        }
        .activeName {
          width: 124%;
          height: 100%;
          background: url('/img/styles/menusIcons/bottomIcon/V3-1bittom.png');
          background-repeat: no-repeat;
          background-position-x: center;
          background-position-y: center;
          background-size: 100% 100%;
          top: 2;
          font-size: 14px;
        }
        &:hover .menu-item-icon-name {
          background: url('/img/styles/menusIcons/bottomIcon/V3-1bittom.png');
          background-repeat: no-repeat;
          background-position-x: center;
          background-position-y: center;
          background-size: 100% 100%;
          width: 124%;
          height: 100%;
          font-size: 12px;
        }

        &:hover .menu-item-icon-ct {
          opacity: 2 !important;
          width: 100% !important;
          height: 100% !important;
          top: -6px !important;
          img.img {
            width: 80%;
            height: 92%;
          }
        }
      }
    }
  }

  .menu-down {
    transform: translate(-50%, 200%);
  }

  .toggle-open-btn {
    cursor: pointer;
    width: 150px;
    height: 13px;
    font-size: 14px;
    background-color: #212631;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-weight: 700;

    &:hover {
      color: rgb(35, 130, 255);
    }
  }
}

// 手机端
.mobile-menu {
  position: absolute;

  .icon {
    cursor: pointer;
    width: 30px;
  }

  .scene {
    position: absolute;
    left: -50px;
    top: 50px;
    overflow: overlay;
    background: url('../../../assets/img/mobile/style3/menu_item_bk.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s ease-in-out;
    transform: translate(-50%, 0);
    height: 480px;
  }
  /* 滚动条的宽度 */
  :deep() .scene::-webkit-scrollbar {
    /* 横向滚动条 */
    width: 2px;
    /* 纵向滚动条 必写 */
    height: 6px;
  }
  /* 滚动条的滑块 */
  :deep() .scene::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 2px;
  }
  .menu-item {
    cursor: pointer;
    flex-shrink: 0;
    /* background-color: #4a57ce; */
    transition: all 0.3s ease-out;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .menu-item-icon-name {
      text-align: center;
      white-space: nowrap;

      /* margin-right: 8px; */
    }

    .menu-item-icon-ct {
      width: 70%;
      height: 50%;
      transition: all 0.3s ease-out;
      margin-bottom: 2px;
      position: relative;

      img.bk {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        left: 0;
        /* top: 4px;*/
      }

      img.pic {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
        top: 0;
      }

      opacity: 0.8;
    }

    .active {
      width: 90%;
      height: 64%;
      opacity: 1;
    }

    &:hover .menu-item-icon-ct {
      width: 90%;
      height: 64%;
    }
  }
}
@media screen and (min-width: 3300px) {
  .v3-style-bottom .menu-box .menu-list .menu-item:hover .menu-item-icon-ct {
    top: -16px !important;
    width: 72% !important;
    height: 92% !important;
  }
  .v3-style-bottom .menu-box .menu-list .menu-item:hover .menu-item-icon-ct img.img {
    width: 80% !important;
  }
  .v3-style-bottom .menu-box .menu-list .menu-item .menu-item-icon-ct {
    top: 43px !important;
  }

  .v3-style-bottom .menu-box .menu-list .menu-item .menu-item-icon-name {
    font-size: 20px !important;
  }
  .v3-style-bottom .menu-box .menu-list .menu-item .menu-item-icon-name:hover {
    background-size: 100% 58% !important;
  }

  .v3-style-bottom .menu-box .menu-list .menu-item .activeName {
    transition: all 0.3s ease-out;
    background-size: 100% 58% !important;
    font-size: 20px !important;
    margin-top: 14px !important;
  }

  .v3-style-bottom .menu-box .menu-list .menu-item .active {
    top: -16px !important;
    width: 72% !important;
    height: 92% !important;
  }

  .v3-style-bottom .menu-box .menu-list .menu-item .menu-item-icon-ct img.img {
    width: 50% !important;
    top: 20px !important;
  }

  .v3-style-bottom .menu-box .menu-list .menu-item .active img.img {
    width: 92% !important;
    top: 30px !important;
  }
}
</style>
